export const PARKING_PRESETS = [
  {
    name: 'Visitor Parking',
    floor: 'P1',
    isAvailable24_7: false,
    startTime: '08:00',
    endTime: '22:00',
    isHandicapAccessible: false,
    isElectricCharging: false,
    rolesDescription: '',
  },
  {
    name: 'Handicap Spot',
    floor: '',
    isAvailable24_7: true,
    startTime: '',
    endTime: '',
    isHandicapAccessible: true,
    isElectricCharging: false,
    rolesDescription: '',
  },
  {
    name: 'EV Charging',
    floor: '',
    isAvailable24_7: true,
    startTime: '',
    endTime: '',
    isHandicapAccessible: false,
    isElectricCharging: true,
    rolesDescription: '',
  },
  {
    name: 'Compact',
    floor: '',
    isAvailable24_7: true,
    startTime: '',
    endTime: '',
    isHandicapAccessible: false,
    isElectricCharging: false,
    rolesDescription: '<p>Compact vehicles only. Maximum vehicle dimensions: 4.5m length x 1.8m width.</p>',
  },
  {
    name: 'Reserved',
    floor: '',
    isAvailable24_7: true,
    startTime: '',
    endTime: '',
    isHandicapAccessible: false,
    isElectricCharging: false,
    rolesDescription: '<p>Reserved for designated residents only.</p>',
  },
  {
    name: 'Motorcycle',
    floor: '',
    isAvailable24_7: true,
    startTime: '',
    endTime: '',
    isHandicapAccessible: false,
    isElectricCharging: false,
    rolesDescription: '<p>Motorcycles and scooters only.</p>',
  },
  {
    name: 'Loading Zone',
    floor: 'Ground',
    isAvailable24_7: false,
    startTime: '07:00',
    endTime: '19:00',
    isHandicapAccessible: false,
    isElectricCharging: false,
    rolesDescription: '<p>Loading and unloading only. 30-minute maximum.</p>',
  },
]
